import { render, staticRenderFns } from "./TraxSettingAircraftCrud.vue?vue&type=template&id=f8089720"
import script from "./TraxSettingAircraftCrud.vue?vue&type=script&lang=js"
export * from "./TraxSettingAircraftCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports